var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign.companies.length > 0
    ? _c(
        "section",
        { staticClass: "campaigns-companies" },
        _vm._l(_vm.campaign.companies, function(company, index) {
          return _c(
            "figure",
            { key: index, staticClass: "campaigns-companies__logo" },
            [
              _c("picture", [
                _c("source", {
                  attrs: { "data-srcset": _vm.getImageSrcset(company) }
                }),
                _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    "data-sizes": "auto",
                    "data-src": _vm.getImageSrc(company)
                  }
                })
              ])
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60db73bd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60db73bd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaigns/campaigns-companies-view.vue
// module id = 609
// module chunks = 45